import React, { useState,useEffect } from "react";
import { useLanguage } from "@src/context/LanguageContext";
import { toast } from "react-toastify";

interface UploadDocumentsProps {
  heading: string;
  documents: { label: string, doc_id : number,doc_file_type:string }[];
  initialDocs?: { label: string; url: string, doc_id: number,file:File,doc_file_type:string }[];
  onDocumentUpload: (uploadedDocument: any) => void;
  onDocumentRemove: (label: string) => void;
  errors?: Record<string, string>;
}

const InsIdUploadDocuments: React.FC<UploadDocumentsProps> = ({ heading, documents,initialDocs = [],onDocumentUpload,onDocumentRemove, errors = {}}) => {
  const [uploadedImages, setUploadedImages] = useState<Record<string, any>>({});
  const {translations} = useLanguage();
  const minFileSize = 25 * 1024;

  useEffect(() => {
    const initialState: Record<string, any> = {};
    initialDocs.forEach((doc) => {
      initialState[doc.label] = {
        url: doc.file ? URL.createObjectURL(doc.file) : doc.url,
        type: doc.file?.type || doc.doc_file_type,
        isUploaded: true,
        doc_id : doc.doc_id
      };
    });
    
    setUploadedImages(initialState);
  }, [initialDocs]);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>, label: string, doc_id:number) => {
    const files = event.target.files;
    if (files && files[0]) {
      if (files[0].size < minFileSize) {
        toast.error(translations.commonMsg?.FILE_SIZE_MIN_25KB || "File size should be at least 25kb");
        event.target.value = "";
        return;
      }

      const newDocument = {
        doc_id,
        label,
        file: files[0],
      };
      const previewImage = {
        file: files[0],
        url: URL.createObjectURL(files[0]),
        type: files[0].type,
      };
      setUploadedImages((prev) => ({
        ...prev,
        [label]: previewImage,
      }));
      onDocumentUpload(newDocument);
    }
  };

  const removeImage = (label: string, doc_id: number) => {
    setUploadedImages((prev) => {
      const updatedImages = { ...prev };
      delete updatedImages[label];
      return updatedImages;
    });
    onDocumentRemove(label);
  };

  const getLabelWithoutNumber = (label: string) => {
    return label.replace(/(\d+)$/, "").trim();
  };

  const isPdfDocument = (doc: UploadDocumentsProps["documents"][number], file: any) => {
    const fileType = `${file?.type || file?.file?.type || doc.doc_file_type || ""}`.toLowerCase();
    const fileName = `${file?.file?.name || file?.url || ""}`.toLowerCase();

    return fileType.includes("pdf") || fileName.includes(".pdf");
  };

  return (
    <React.Fragment>
        <div className="col-md-12">
          <div className="upload-heading-text">{heading}</div>
        </div>
        {documents.map((doc, index) => {
          const file = uploadedImages[doc.label];

          return (
          <div className="col-md-2 p-lg-t" key={index}>
            {!file ? (
              <div role="presentation" className="add-document-proof">
                <input
                  type="file"
                  id={`upload-image-input-${index}`}
                  name="documents[]"
                  title=""
                  onChange={(e) => handleFileUpload(e, doc.label,doc.doc_id)}
                />
                <i className="ic-add"> </i>
                <span>{translations.commonMsg?.['upload'] || translations.commonMsg?.loading}</span>
              </div>
            ) : (
              <div role="presentation" className="upload-image-proof">
                <span className="close-icn" onClick={() => removeImage(doc.label, file.doc_id)}>
                  <i className="ic-clearclose"></i>
                </span>
                {
                  isPdfDocument(doc, file) ? (
                    <a href={file?.url} target="_blank" rel="noreferrer"><i className="ic-pdf-file icons-normal"></i></a>
                  ) : (
                    <img src={file?.url} alt={doc.label+'1'} />
                  )
                }
              </div>
            )}
            <p className="doc-tag-name">{getLabelWithoutNumber(translations.RuleEngineAgency?.[doc.label] || doc.label)} {(doc.label === "Upload KTP ID" || getLabelWithoutNumber(doc.label) === "Bank Statement") ? "*" : ''}</p>
            {
                doc.label === "Upload KTP ID" &&errors && errors.apiDocs
                    ?
                    <span className="error-txt error-docs-upload">{errors.apiDocs}</span>
                    :
                    ''
            }
            {
                getLabelWithoutNumber(doc.label) === "Bank Statement" && errors && errors.bankDocs
                    ?
                    <span className="error-txt error-docs-upload">{errors.bankDocs}</span>
                    :
                    ''
            }
          </div>
          );
        })}
    </React.Fragment>
  );
};

export default InsIdUploadDocuments;
